import { Box } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  '& .HSSubTitleAndSearchContainer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: theme.spacing(11),
    marginBottom: theme.spacing(4),
    gap: theme.spacing(3),
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      marginTop: theme.spacing(7),
      marginBottom: theme.spacing(7),
    },
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(5),
    },
  },

  '& .HSTermsBtn': {
    textDecoration: 'underline',
    fontWeight: 700,
    fontSize: theme.spacing(2),
    padding: 0,
    minHeight: 'unset',
  },

  '& .HSSubTitle': {
    textTransform: 'uppercase',
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
      fontSize: theme.spacing(2),
    },
  },

  '& .HSTouersCount': {
    color: theme.palette.primary.main,
    paddingRight: theme.spacing(0.5),
    fontSize: theme.spacing(2.5),
  },

  '& .HSSearchAndTermsContainer': {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  '& .HSSearchInput': {
    backgroundColor: theme.palette.secondary.main,
    backdropFilter: `blur(${theme.spacing(1)})`,
    borderRadius: theme.spacing(1),
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      width: 400,
    },

    '& input': {
      color: theme.palette.text.secondary,
      paddingTop: theme.spacing(1.8),
      paddingBottom: theme.spacing(1.8),
    },
    '& svg': {
      color: theme.palette.text.secondary,
    },

    '& .MuiOutlinedInput-root': {
      fontSize: theme.typography.pxToRem(16),
      paddingLeft: theme.spacing(3),

      '& fieldset': {
        borderColor: theme.palette.divider[7],
      },
      '&:hover fieldset': {
        backgroundColor: `${alpha(theme.palette.secondary.main, 0.25)}`,
        borderColor: `${theme.palette.divider[7]} !important`,
      },
      '&.Mui-focused fieldset': {
        borderColor: `${theme.palette.common.white} !important`,
        color: theme.palette.text.primary,
        '& svg': {
          color: theme.palette.text.primary,
        },
      },
    },
  },
}));

export default StyledBox;
